import React, { useRef } from 'react';
import styled from 'astroturf/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import useOnClickOutside from 'js/utils/hooks/useOnClickOutside';
import AccountMenu from 'js/header/FocusedNav/AccountMenu';
import DoubleDigitCountBubble from 'js/header/FocusedNav/DoubleDigitCountBubble';
import { Props as AccountMenuProps } from 'js/header/FocusedNav/AccountMenu';
import _PositionedDoubleDigitCountBubble from "AccountMenuButton-PositionedDoubleDigitCountBubble.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenuButton.tsx?styleId=PositionedDoubleDigitCountBubble";
import _UserButton from "AccountMenuButton-UserButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenuButton.tsx?styleId=UserButton";
import _ButtonProfilePic from "AccountMenuButton-ButtonProfilePic.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenuButton.tsx?styleId=ButtonProfilePic";
import _Caret from "AccountMenuButton-Caret.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenuButton.tsx?styleId=Caret";
import _MenuContainer from "AccountMenuButton-MenuContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenuButton.tsx?styleId=MenuContainer";
import _UserName from "AccountMenuButton-UserName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenuButton.tsx?styleId=UserName";


const PositionedDoubleDigitCountBubble = /*#__PURE__*/styled(DoubleDigitCountBubble, null, {
  displayName: "PositionedDoubleDigitCountBubble",
  styles: _PositionedDoubleDigitCountBubble
});

const UserButton = /*#__PURE__*/styled("button", null, {
  displayName: "UserButton",
  styles: _UserButton
});

const ButtonProfilePic = /*#__PURE__*/styled("img", null, {
  displayName: "ButtonProfilePic",
  styles: _ButtonProfilePic
});

const Caret = /*#__PURE__*/styled(FontAwesomeIcon, null, {
  displayName: "Caret",
  styles: _Caret
});

const MenuContainer = /*#__PURE__*/styled("div", null, {
  displayName: "MenuContainer",
  styles: _MenuContainer
});

const UserName = /*#__PURE__*/styled("div", null, {
  displayName: "UserName",
  styles: _UserName
});

type Props = AccountMenuProps & {
  totalCount: number;
  open: boolean;
  setOpen: (openness: boolean) => void;
  showNotificationBadges?: boolean;
};

const AccountMenuButton = (props: Props) => {
  const {
    totalCount,
    open,
    setOpen,
    showNotificationBadges = true,
    ...restProps
  } = props;

  const buttonRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  useOnClickOutside([buttonRef, menuRef], () => setOpen(false));

  return (
    <>
      <UserButton
        ref={buttonRef}
        onClick={() => setOpen(!open)}
        aria-pressed={open}
      >
        {currentUser != null && (
          <ButtonProfilePic src={$image_url(currentUser.photo)} />
        )}
        {showNotificationBadges && (
          <PositionedDoubleDigitCountBubble count={totalCount} />
        )}
        <UserName>{currentUser?.first_name}</UserName>
        <Caret icon={faCaretDown} />
      </UserButton>
      {open && (
        <MenuContainer ref={menuRef}>
          <AccountMenu
            {...restProps}
            setOpen={setOpen}
            showNotificationBadges={showNotificationBadges}
          />
        </MenuContainer>
      )}
    </>
  );
};

export default AccountMenuButton;
